import React from "react";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon/FnrIcon";

export default function BoardError() {
  return (
    <Wrapper>
      <FnrIcon far fa-exclamation-triangle style={{ fontSize: 28 }} />
      <Message>
        Oh no! We hit a snag while retrieving the list of respondents. Please
        try again later, or contact{" "}
        <a href="mailto:help@flocknote.com" target="_blank" rel="noreferrer">
          help@flocknote.com
        </a>
        .
      </Message>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  max-width: 340px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 18px;
`;

const Message = styled.div`
  a {
    color: var(--fnBlue) !important;
  }
`;
